import { Money } from '@/models/money';
import { StatisticType } from '@/models/statistic';
import { isValid } from 'date-fns';
import { formatStarjackDate } from '@/utils/time';

export type AggregatedTicket = {
    liftOperatorTicketType: string;
    duration: number;
    personName: string;
    sumSales: Money;
    sumCancellations: Money;
    totalSales: number;
    totalCancellations: number;
    sumDepositAmounts: Money;
    sumCancelledDepositAmounts: Money;
    name: string;
    conditions: string[];
};

export type AggregatedTicketSearchParams = {
    orderDateFrom?: Date;
    orderDateTo?: Date;
    productionDateFrom?: Date;
    productionDateTo?: Date;
    ticketStartFrom?: Date;
    ticketStartTo?: Date;
    cancellationDateStartFrom?: Date;
    cancellationDateStartTo?: Date;
    identificationType?: string;
    integrationRefSet?: boolean;
    statisticTypes?: StatisticType[];
};

export const convertAggregatedTicketSearchParamsToBackend = (
    params: AggregatedTicketSearchParams
): AggregatedTicketSearchParams => {
    const backendParams: AggregatedTicketSearchParams = {};

    for (const key in params) {
        if (
            Object.prototype.hasOwnProperty.call(params, key) &&
            params[key] !== null &&
            params[key] !== undefined
        ) {
            if (isValid(params[key])) {
                backendParams[key] = formatStarjackDate(params[key]);
            } else {
                backendParams[key] = params[key];
            }
        }
    }

    return backendParams;
};

type MoneyField =
    | 'sumSales'
    | 'sumCancellations'
    | 'sumDepositAmounts'
    | 'sumCancelledDepositAmounts';

export const getSumMoney = (tickets: AggregatedTicket[], key: MoneyField) =>
    tickets.map((ticket) => ticket[key]);
